import * as React from 'react';

import { IBuilder, ISeller } from '../../types/newbuildingsCompare';
import { PhoneButton } from '../../components/NewbuildingCallToAction/PhoneButton';
import { useDynamicPhoneCall } from './useDynamicPhoneCall';

export interface ISellerPhoneProps {
  newbuildingId: number;
  url: string;
  target: IBuilder | ISeller;
  isBuilder: boolean;
  onShowPhone?: () => void;
}

export const SellerPhone: React.FC<ISellerPhoneProps> = ({ newbuildingId, url, target, isBuilder, onShowPhone }) => {
  const dial = useDynamicPhoneCall({
    newbuildingId,
    url,
    target,
    sellerType: isBuilder ? 'builders' : 'agents',
    onShowPhone,
  });

  return <PhoneButton onlyIcon onClick={dial} testId="ContactsModalPhoneButton" />;
};
